<p>{{ 'thank-you-for-booking-ticket-in-bok' | translate }}!</p>
<div>{{ 'reservation-details' | translate }}:</div>

<h5>
    {{ 'your-code' | translate }}: 
    <span class="text-primary">{{ ticketReservation.code }}</span>
</h5>

<div>{{ 'category' | translate }}: <span class="text-primary font-weight-bold">{{ categoryName | translate }}</span></div>
<div>{{ 'date' | translate }}:
    <span class="text-primary font-weight-bold">{{ displayReservationTime | date:'dd/MM/yyyy HH:mm' }}</span>
</div>
<div>{{ 'selected-location' | translate }}:
    <span class="text-primary font-weight-bold">{{ service.getSelectedLocation() }}</span>
</div>

<div class="alert alert-info my-2">
    <i class="fas fa-info-circle"></i>
    {{ 'code-info' | translate }}.
</div>

<button (click)="refresh()" class="btn btn-danger">{{ 'new-reservation' | translate }}</button>
